import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CircleOutlineBlueIcon, DoDisturbGrayIcon, } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * コンサルタント：条件相談ステータス表示用のコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalNegotiateStatusIconTextGroup = (props) => {
    const { className = '', isNegotiable, isOfferDisabled } = props;
    // 提案済
    if (isOfferDisabled) {
        return (_jsx(IconTextGroup, Object.assign({ className: className }, { children: _jsxs(_Fragment, { children: [_jsx(DoDisturbGrayIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'textGray', size: 'sm' }, { children: "\u7DE0\u5207\u6E08" }))] }) })));
    }
    // 相談不可
    if (!isNegotiable) {
        return (_jsx(IconTextGroup, Object.assign({ className: className }, { children: _jsxs(_Fragment, { children: [_jsx(DoDisturbGrayIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'textGray', size: 'sm' }, { children: "\u76F8\u8AC7\u4E0D\u53EF" }))] }) })));
    }
    // 受付中
    return (_jsx(IconTextGroup, Object.assign({ className: className }, { children: _jsxs(_Fragment, { children: [_jsx(CircleOutlineBlueIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: "\u53D7\u4ED8\u4E2D" }))] }) })));
};
